import { createSlice } from '@reduxjs/toolkit'
import { get } from 'lodash'

const initialState = {
  currentPage: 1,
  selectedInvoiceId: null,
  invoices: [],
  totalPages: 0,
  isLoading: false,
  isDialogOpen: false,
  workOrderIds: [],
  accountIds: [],
}

const bulkInvoicePreviewSlice = createSlice({
  name: 'bulkInvoicePreview',
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload
    },
    setSelectedInvoiceId: (state, action) => {
      state.selectedInvoiceId = action.payload
      // Find the index of the selected invoice and update current page
      const index = state.invoices.findIndex(invoice => invoice.id === action.payload)
      if (index !== -1) {
        state.currentPage = index + 1
      }
    },
    setInvoices: (state, action) => {
      state.invoices = action.payload
      state.totalPages = action.payload.length
      // If we have invoices but no selected invoice, select the first one
      if (action.payload.length > 0 && !state.selectedInvoiceId) {
        state.selectedInvoiceId = action.payload[0].id
      }
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload
    },
    nextInvoice: state => {
      if (state.currentPage < state.totalPages) {
        state.currentPage += 1
        state.selectedInvoiceId = get(state.invoices, [state.currentPage - 1, 'id'], null)
      }
    },
    previousInvoice: state => {
      if (state.currentPage > 1) {
        state.currentPage -= 1
        state.selectedInvoiceId = get(state.invoices, [state.currentPage - 1, 'id'], null)
      }
    },
    resetState: () => initialState,
    openBulkInvoiceCreationDialog: (state, action) => {
      state.isDialogOpen = true
      state.workOrderIds = get(action, 'payload.workOrderIds', [])
      state.accountIds = get(action, 'payload.accountIds', [])
    },
    closeBulkInvoiceCreationDialog: state => {
      state.isDialogOpen = false
      state.workOrderIds = []
      state.accountIds = []
    },
  },
})

export const {
  setCurrentPage,
  setSelectedInvoiceId,
  setInvoices,
  setIsLoading,
  nextInvoice,
  previousInvoice,
  resetState,
  openBulkInvoiceCreationDialog,
  closeBulkInvoiceCreationDialog,
} = bulkInvoicePreviewSlice.actions

// Selectors
export const selectCurrentPage = state => state.bulkInvoicePreview.currentPage
export const selectSelectedInvoiceId = state => state.bulkInvoicePreview.selectedInvoiceId
export const selectInvoices = state => state.bulkInvoicePreview.invoices
export const selectTotalPages = state => state.bulkInvoicePreview.totalPages
export const selectIsLoading = state => state.bulkInvoicePreview.isLoading
export const selectCurrentInvoice = state => {
  const { invoices, currentPage } = state.bulkInvoicePreview
  return get(invoices, [currentPage - 1], null)
}
export const selectIsDialogOpen = state => state.bulkInvoicePreview.isDialogOpen
export const selectWorkOrderIds = state => state.bulkInvoicePreview.workOrderIds
export const selectAccountIds = state => state.bulkInvoicePreview.accountIds

export default bulkInvoicePreviewSlice.reducer
